import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { EditAJEvent } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'


export default class JourneyOverviewModal extends Component {
  static propTypes = {
    aJDetail: PropTypes.object,
    ajPeId: PropTypes.number,
    colorClass: PropTypes.string,
    modalId: PropTypes.string
  }

  render() {
    const { colorClass, modalId, aJDetail, ajPeId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title="Edit Journey"
        titleKey="moduleTitle.edit_journey"
      >
        <MaterialModal.Content noFooter>
          <EditAJEvent
            {...this.props}
            params={this.props.params}
            data={{
              ...get(aJDetail, 'ajEvent'),
              aim: get(aJDetail, 'aim') || get(aJDetail, 'ajEvent.aim')
            }}
            ajPeId={ajPeId}
          />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
